module.exports = __webpack_public_path__ + "static/media/top-venues-video.a3e6e658.mp4";